import { BOTTOM_BAR, BUTTON_GROUP } from "src/config-global";

// ----------------------------------------------------------------------

export default function Dialog(theme) {
    return {
        MuiDialog: {
            styleOverrides: {
                paper: ({ ownerState }) => ( {
                    alignSelf: "center",
                    width: "100%",
                    minWidth: "330px",
                    maxWidth: "500px",
                    maxHeight: "min(85vh, 900px)",
                    boxShadow: theme.customShadows.dialog,
                    borderRadius: theme.shape.borderRadius,
                    ...( !ownerState.fullScreen && {
                        margin: theme.spacing(2)
                    } )
                } ),
                paperFullWidth: {
                    maxWidth: "600px"
                },
                paperFullScreen: {
                    borderRadius: 0
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(3)
                }
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(0, 3)
                },
                dividers: {
                    borderTop: 0,
                    borderBottomStyle: "dashed",
                    paddingBottom: theme.spacing(3)
                }
            }
        },
        MuiDialogActions: {
            defaultProps: {
                disableSpacing: true
            },
            styleOverrides: {
                root: {
                    height: `${BOTTOM_BAR.HEIGHT}px`,
                    paddingTop: `${BOTTOM_BAR.PADDING_Y}px`,
                    paddingBottom: `${BOTTOM_BAR.PADDING_Y}px`,
                    paddingLeft: `${BOTTOM_BAR.PADDING_X}px`,
                    paddingRight: `${BOTTOM_BAR.PADDING_X}px`,
                    borderTop: "1px solid",
                    borderColor: theme.palette.line,
                    backgroundColor: theme.palette.background.default,
                    // padding: theme.spacing(3),
                    "& > :not(:first-of-type)": {
                        // marginLeft: theme.spacing(1.5),
                        marginLeft: `${BUTTON_GROUP.SPACING_X}px`
                    }
                }
            }
        }
    };
}
